import { createSlice } from "@reduxjs/toolkit";

import { getBasicInformationRes } from "core/http/service/personnelInformation/resTypes";
import { isDateFormat } from "helper/utils";
import { set } from "lodash";
import moment from "moment";

interface InitialState {
  currentData: getBasicInformationRes;
  formData: getBasicInformationRes;
  changedData: {
    [key: string]: any;
  };
}

const initialState: InitialState = {
  currentData: {
    bornAddress: "",
    fullName: "",
    bornDate: "",
    domicileAddress: "",
    email: "",
    gender: "",
    idIssueDate: null,
    idIssuePlaceCode: "",
    idIssuePlace: "",
    idNo: "",
    mobile: "",
    taxCode: "",
    files: [],
    files_files: [],
    commit: false,
  },
  formData: {
    bornAddress: "",
    fullName: "",
    bornDate: "",
    domicileAddress: "",
    email: "",
    gender: "",
    idIssueDate: null,
    idIssuePlaceCode: "",
    idIssuePlace: "",
    idNo: "",
    mobile: "",
    taxCode: "",
    files: [],
    files_files: [],
    commit: false,
  },
  changedData: undefined,
};

const formEditBasicInformationSlice = createSlice({
  name: "editBasicInformation",
  initialState,
  reducers: {
    updateFormEditBasicInformation: (state, action) => {
      const keys = Object.keys(action.payload);
      for (let i = 0; i < keys.length; i++) {
        set(state.formData, keys[i], action.payload[keys[i]]);
      }
    },
    updateBasicInformationCurrentData: (state, action) => {
      const isIssueDateValid = isDateFormat(action.payload.idIssueDate);

      const idIssueDate = !action.payload.idIssueDate
        ? null
        : isIssueDateValid
          ? action.payload.idIssueDate
          : moment(action.payload.idIssueDate).format("DD/MM/YYYY");

      state.currentData = {
        ...action.payload,
        idIssueDate,
      };
    },
    updateBasicInformationChangedData: (state, action) => {
      state.changedData = action.payload;
    },

    resetFormEditBasicInformation: () => {
      return { ...initialState };
    },
  },
});

export const {
  updateFormEditBasicInformation,
  resetFormEditBasicInformation,
  updateBasicInformationChangedData,
  updateBasicInformationCurrentData,
} = formEditBasicInformationSlice.actions;

export default formEditBasicInformationSlice.reducer;
